// Single source of truth for the business's real-world contact details and social
// links, so the phone/WhatsApp number, map location, and social profiles only need
// to be updated in one place if they ever change.
export const CONTACT = {
  phoneDisplay: '+973 3334 8358',
  phoneTel: '+97333348358',
  whatsappNumber: '97333348358',
  email: 'info@prestigemesbah.com',
  addressAr: 'مبنى #42، مبنى المحمدية، طريق 308، مجمع 304، شارع البلدية، المنامة، البحرين',
  addressEn: 'Bldg #42, Al Mohammediya Building, Road 308, Block 304, Manama, Bahrain',
  // The short link shared by the business — used for "open in Google Maps" / "get directions".
  mapShareUrl: 'https://maps.app.goo.gl/TSV1iGb3QA2yzKzu6?g_st=ic',
  // No-API-key embeddable map URL resolved from the share link above, centered on the same address.
  mapEmbedUrl: 'https://www.google.com/maps/embed?origin=mfe&pb=!1m3!2m1!1sPrestige+Mesbah,+Al+Mohammediya+Building,+Road+308,+Block+304,+Manama,+Bahrain!6i16',
  instagram: 'https://www.instagram.com/prestige_mesbah?igsh=MWNrcXg1Y2FoOWtrdA%3D%3D&utm_source=qr',
  tiktok: 'https://www.tiktok.com/@prestigemisbah?_r=1&_t=ZS-98KBlhoQXkz',
  facebook: 'https://www.facebook.com/share/1CdS3RDTA4/?mibextid=wwXIfr',
};
